/**
 * @format
 * @flow strict-local
 */
// DEPENDENCIES

import React, {
	useEffect,
	useState
} from "react";

// HOOK

const useDimensions = (ref) => {
	const [
		dimensions, 
		setDimensions
	] = useState(null);

	// Lifecycle

	// Note - Run on bootstrap
	useEffect(
		() => {
			window.addEventListener(
				"resize", 
				windowChangeHandler
			);

			windowChangeHandler();

			return () => {
				window.removeEventListener(
					"resize", 
					windowChangeHandler
				);
			};
		}, 
		[]
	);

	// Events

	/**
	 * windowChangeHandler - ...
	 * 
	 * @param {object} e ... 
	 */
	const windowChangeHandler = (e) => {
		if(!ref.current) {
			return;
		}

		const boundingRect = ref.current.getBoundingClientRect();

		setDimensions({
			height: Math.round(boundingRect.height),
			width: Math.round(boundingRect.width)
		});
	};

	// Return

	return dimensions;
};

// EXPORT

export default useDimensions;
